/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Delivered_TitleInputs */

const vi_order_carrier_delivered_title = /** @type {(inputs: Order_Carrier_Delivered_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận đơn vị vận chuyển đã giao`)
};

/**

* @param {Order_Carrier_Delivered_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_delivered_title = /** @type {((inputs?: Order_Carrier_Delivered_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Delivered_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_delivered_title(inputs)
});